/* Wave2Wear newsletter popup — opens once per visitor (localStorage), video + 10% off. */
(function () {
  var KEY = 'w2w_pop_seen';
  var pop = document.getElementById('w2wPopup');
  if (!pop) return;

  function open() { pop.hidden = false; requestAnimationFrame(function () { pop.classList.add('is-open'); }); }
  function close() {
    pop.classList.remove('is-open');
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
    setTimeout(function () { pop.hidden = true; }, 320);
  }
  pop.querySelectorAll('[data-pop-close]').forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('is-open')) close(); });

  // If the newsletter form just posted successfully (page reloaded), show the thank-you.
  if (pop.querySelector('.w2w-pop__success')) {
    open();
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
    return;
  }
  // Otherwise auto-open once, after the delay set in Theme settings.
  var seen; try { seen = localStorage.getItem(KEY); } catch (e) {}
  var delay = (parseFloat(pop.getAttribute('data-delay')) || 3) * 1000;
  if (!seen) setTimeout(open, delay);
})();
